import { Link } from 'react-router-dom'
import './Error.css'

function ServerError() {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="error-page error-500">
      <div className="error-content">
        <div className="error-illustration">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="80" fill="url(#error-gradient-500)" fillOpacity="0.1"/>
            <text x="100" y="115" textAnchor="middle" className="error-code-svg">500</text>
            <defs>
              <linearGradient id="error-gradient-500" x1="0" y1="0" x2="200" y2="200">
                <stop stopColor="#EF4444"/>
                <stop offset="1" stopColor="#DC2626"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        <h1 className="error-title">Something went wrong</h1>
        <p className="error-description">
          We're experiencing some technical difficulties. Our team has been notified 
          and we're working to fix the issue.
        </p>
        
        <div className="error-actions">
          <button onClick={handleRefresh} className="btn btn-primary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="23 4 23 10 17 10"/>
              <polyline points="1 20 1 14 7 14"/>
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
            </svg>
            Try again
          </button>
          <Link to="/" className="btn btn-secondary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
            Go to homepage
          </Link>
        </div>
        
        <div className="error-status">
          <div className="status-item">
            <span className="status-dot online"></span>
            <span>API Services</span>
          </div>
          <div className="status-item">
            <span className="status-dot degraded"></span>
            <span>Web Application</span>
          </div>
          <a href="https://status.hubthrill.com" className="status-link" target="_blank" rel="noopener noreferrer">
            Check system status
          </a>
        </div>
      </div>
      
      <div className="error-decoration">
        <div className="decoration-orb orb-1 error"></div>
        <div className="decoration-orb orb-2 error"></div>
        <div className="decoration-orb orb-3 error"></div>
      </div>
    </div>
  )
}

export default ServerError
